import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './Legal.module.css';

export default function Privacy() {
  return (
    <section className={styles.section}>
      <Helmet>
        <title>Политика конфиденциальности — ООО Советник</title>
        <meta name="description" content="Политика конфиденциальности сайта konsultant-sovetnik.ru. Порядок обработки и защиты персональных данных пользователей." />
        <link rel="canonical" href="https://konsultant-sovetnik.ru/privacy" />
      </Helmet>
      <div className={styles.container}>
        <h1 className={styles.title}>Политика конфиденциальности</h1>
        <p className={styles.date}>Дата последнего обновления: 17 марта 2026 г.</p>

        <div className={styles.content}>
          <h2>1. Общие положения</h2>
          <p>
            Настоящая Политика конфиденциальности (далее — Политика) определяет порядок обработки
            и защиты персональных данных физических лиц (далее — Пользователи), которые используют
            сайт konsultant-sovetnik.ru (далее — Сайт), принадлежащий ООО «Советник»
            (далее — Оператор).
          </p>
          <p>
            Оператор обрабатывает персональные данные в соответствии с Федеральным законом
            от 27.07.2006 № 152-ФЗ «О персональных данных».
          </p>

          <h2>2. Персональные данные, которые мы собираем</h2>
          <p>Оператор может обрабатывать следующие персональные данные Пользователя:</p>
          <ul>
            <li>Фамилия, имя, отчество</li>
            <li>Адрес электронной почты</li>
            <li>Номер телефона</li>
            <li>Сведения, указанные Пользователем в формах обратной связи</li>
            <li>Данные о посещении сайта (IP-адрес, тип браузера, время посещения)</li>
          </ul>

          <h2>3. Цели обработки персональных данных</h2>
          <p>Оператор обрабатывает персональные данные в следующих целях:</p>
          <ul>
            <li>Обработка входящих запросов и обратная связь</li>
            <li>Предоставление консультационных и юридических услуг</li>
            <li>Направление информационных материалов (с согласия Пользователя)</li>
            <li>Улучшение качества обслуживания и работы Сайта</li>
          </ul>

          <h2>4. Правовые основания обработки</h2>
          <p>
            Обработка персональных данных осуществляется на основании согласия Пользователя,
            выраженного путём заполнения форм на Сайте и проставления отметки о согласии с
            настоящей Политикой, а также в целях исполнения договорных обязательств.
          </p>

          <h2>5. Порядок обработки и защиты данных</h2>
          <p>
            Оператор принимает необходимые организационные и технические меры для защиты
            персональных данных от несанкционированного доступа, изменения, раскрытия или
            уничтожения. Доступ к персональным данным имеют только уполномоченные сотрудники
            Оператора.
          </p>

          <h2>6. Передача данных третьим лицам</h2>
          <p>
            Оператор не передаёт персональные данные третьим лицам, за исключением случаев,
            предусмотренных законодательством Российской Федерации.
          </p>

          <h2>7. Сроки хранения данных</h2>
          <p>
            Персональные данные хранятся в течение срока, необходимого для достижения целей
            их обработки, но не более 3 (трёх) лет с момента последнего обращения Пользователя,
            если иное не предусмотрено законодательством.
          </p>

          <h2>8. Права Пользователя</h2>
          <p>Пользователь имеет право:</p>
          <ul>
            <li>Получить информацию об обработке своих персональных данных</li>
            <li>Требовать уточнения, блокирования или уничтожения своих данных</li>
            <li>Отозвать согласие на обработку персональных данных</li>
            <li>Обжаловать действия Оператора в Роскомнадзор</li>
          </ul>
          <p>
            Для реализации своих прав Пользователь может направить запрос на адрес
            электронной почты: <a href="mailto:info@konsultant-sovetnik.ru">info@konsultant-sovetnik.ru</a>.
          </p>

          <h2>9. Cookies и аналитика</h2>
          <p>
            Сайт может использовать файлы cookies для улучшения работы и анализа посещаемости.
            Пользователь может отключить cookies в настройках браузера.
          </p>

          <h2>10. Контактная информация</h2>
          <p>
            ООО «Советник»<br />
            Адрес: Россия, г. Тверь, пер. Спортивный, д.1А, оф.9<br />
            Email: <a href="mailto:info@konsultant-sovetnik.ru">info@konsultant-sovetnik.ru</a><br />
            Телефон: <a href="tel:+79109369889">+7 (910) 936-98-89</a>
          </p>
        </div>
      </div>
    </section>
  );
}
